import { encounterCreatureField, hasCampaignPermission, hasPlayerPermission, itemsCol } from '../shared/array-types';
import { statusRows, statusItemId } from '../janus-engine/statuses/expiry';
import { HIDDEN } from '../janus-engine/ability/stealth-hide';

type Row = Record<string, unknown>;
type Preview = { type: string; roll_private?: number; ability_id?: string };

export function aoePreviewVisibleToViewer(frame: Preview, casterRow: Row | null, abilityRow: Row | null,
    viewer: { isGM?: boolean }): boolean {
    if (frame.type === 'ft3d_aoe_placement_preview_clear') return true;
    if (!casterRow) return false;
    const restricted = frame.roll_private !== 0
        || Number(encounterCreatureField(casterRow.encounter_creatures, 'encounter_creature_private') ?? 0) !== 0
        || Number(itemsCol(casterRow, 'item_private') ?? 0) !== 0
        || statusRows(casterRow, 'target').some(status => statusItemId(status) === HIDDEN)
        || Boolean(frame.ability_id && (!abilityRow || Number(itemsCol(abilityRow, 'item_private') ?? 0) !== 0));
    return !restricted || viewer.isGM === true || hasCampaignPermission(casterRow) || hasPlayerPermission(casterRow);
}
